import React from 'react';
import PropTypes from 'prop-types';
import {TableCell, TableRow} from "@mui/material";
import {greyishBlue50, greyishBlue300} from "../../../../../../../assets/jss/main";

DayTracker.propTypes = {
    data: PropTypes.object.isRequired
};

function DayTracker({data}) {

    return (
        <TableRow>
            <TableCell sx={{textAlign: "center", backgroundColor: greyishBlue50}}>{data.day}</TableCell>
            <TableCell sx={{textAlign: "center"}}>
                <span style={{color: 0 < data.waiting_for_picking ? "black" : greyishBlue300}}>
                    {data.waiting_for_picking}
                </span>
            </TableCell>

            <TableCell sx={{textAlign: "center"}}>
                <span style={{color: 0 < data.in_picking ? "black" : greyishBlue300}}>
                    {data.in_picking}
                </span>
            </TableCell>

            <TableCell sx={{textAlign: "center"}}>
                <span style={{color: 0 < data.ready_to_sort ? "black" : greyishBlue300}}>
                    {data.ready_to_sort}
                </span>
            </TableCell>

            <TableCell sx={{textAlign: "center"}}>
                <span style={{color: 0 < data.ready_to_pack ? "black" : greyishBlue300}}>{
                    data.ready_to_pack}
                </span>
            </TableCell>

            <TableCell sx={{textAlign: "center"}}>
                <span style={{color: 0 < data.packing ? "black" : greyishBlue300}}>
                    {data.packing}
                </span>
            </TableCell>

            <TableCell sx={{textAlign: "center"}}>
                <span style={{color: 0 < data["to-ship"] ? "black" : greyishBlue300}}>
                    {data["to-ship"]}
                </span>
            </TableCell>
        </TableRow>
    );
}

export default DayTracker;